import { IPlainObject } from '../models';

export function takeExceptKeys<T extends IPlainObject>(
  value: T & IPlainObject,
  keys: string[],
): T {
  const newObj = { ...value };

  keys.forEach((key) => delete newObj[key]);

  return newObj;
}

export function filterByKeys<T extends IPlainObject>(
  value: T & IPlainObject,
  keys: string[],
): T {
  return Object.keys(value).reduce(
    (acum, key): T =>
      keys.includes(key) ? { ...acum, [key]: value[key] } : acum,
    {} as T,
  );
}
